'use strict';

const saUniqueEmailValidator = [
  '$q',
  '$http',
  'utils',

  function ($q, $http, utils) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function ($scope, $elementm, $attr, ngModel) {
        ngModel.$asyncValidators.unique = function (modelValue, viewValue) {
          var promise;
          var postData;

          if (!viewValue) {
            promise = $q.resolve();
          } else {
            postData = {
              email: viewValue
            };

            promise = $http.post(utils.getApiUrl('authentication/profile_registration_email_check'), postData)
              .catch(function () {
                return true;
              })
              .then(function (response) {
                return (response.data && response.data.exists) ? $q.reject() : $q.resolve();
              });
          }

          return promise;
        };
      }
    };
  }
];

export default saUniqueEmailValidator;



// WEBPACK FOOTER //
// ./app/src/directives/unique_email_validator.js